
import React from 'react';

export const TextAnalysisHeader = () => {
  return (
    <div className="mb-6">
      <h1 className="text-2xl font-bold">Text Analysis</h1>
      <p className="text-muted-foreground mt-1">
        Analyze text for AI-generated content, fraud patterns, and linguistic anomalies.
      </p>
    </div>
  );
};
